import { ChangeEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'

import { breakManagementActions } from '../breakManagementSagas'
import { selectBreakManagement } from '../breakManagementSelectors'
import { setSettingsDraft } from '../breakManagementSlice'

const MAX_CAP = 500

const isValidCap = (value: string) => /^\d+$/.test(value) && Number(value) <= MAX_CAP

const useBreakSettingsForm = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const { settingsDraft, settingsLoaded, settingsError, isSavingSettings } = useSelector(selectBreakManagement)
  const { maxWeekday, maxSaturday } = settingsDraft

  const weekdayError = settingsLoaded && !isValidCap(maxWeekday)
  const saturdayError = settingsLoaded && !isValidCap(maxSaturday)
  const canSubmit = settingsLoaded && isValidCap(maxWeekday) && isValidCap(maxSaturday) && !isSavingSettings

  const onMaxWeekdayChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    dispatch(setSettingsDraft({ maxWeekday: event.currentTarget.value }))
  }

  const onMaxSaturdayChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    dispatch(setSettingsDraft({ maxSaturday: event.currentTarget.value }))
  }

  const submit = () => {
    if (!canSubmit) return

    dispatch({
      type: breakManagementActions.UPDATE_SETTINGS,
      settings: { max_weekday: Number(maxWeekday), max_saturday: Number(maxSaturday) },
      enqueue,
    })
  }

  return {
    t,
    maxWeekday,
    maxSaturday,
    onMaxWeekdayChange,
    onMaxSaturdayChange,
    maxCap: MAX_CAP,
    settingsError,
    inputsDisabled: !settingsLoaded,
    weekdayError,
    saturdayError,
    canSubmit,
    submit,
  }
}

export default useBreakSettingsForm
